import { t } from "ttag";

import { ROOT_COLLECTION } from "metabase/common/collections/constants";
import { CollectionListView } from "metabase/common/components/CollectionListView";
import * as Urls from "metabase/urls";
import { useListTenantsQuery } from "metabase-enterprise/api";
import type { IconName } from "metabase-types/api";

export const TenantUsersList = () => {
  const { data, isLoading } = useListTenantsQuery({ status: "active" });

  const tenants = data?.data ?? [];

  const crumbs = [
    {
      title: ROOT_COLLECTION.name,
      to: Urls.collection({ id: "root", name: "" }),
    },
    { title: t`Tenant users' personal collections` },
  ];

  const items = tenants.map((tenant) => ({
    key: tenant.id,
    name: tenant.name,
    icon: "group" as const satisfies IconName,
    link: Urls.tenantUsersPersonalCollectionsForTenant(tenant.id),
  }));

  return (
    <CollectionListView crumbs={crumbs} loading={isLoading} items={items} />
  );
};
